/**
 * @fileoverview ESM mirror of ../hostMatching.js.
 *
 * Drift between this file and the CJS source is caught by
 * `tests/esm/native-import.test.mjs`.
 *
 * @module @puffin-core/cross-app-policy/hostMatching
 */

const IPV4_REGEX = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/;

function stripPort(hostname) {
  const colonIdx = hostname.indexOf(':');
  return colonIdx >= 0 ? hostname.slice(0, colonIdx) : hostname;
}

function isLocalhostSource(scheme, hostname) {
  if (scheme !== 'http') return false;
  if (typeof hostname !== 'string' || hostname.length === 0) return false;
  return isLocalWorkstationHost(stripPort(hostname));
}

function isBareLocalHost(hostname) {
  if (typeof hostname !== 'string') return false;
  const host = hostname.toLowerCase();
  return host === 'localhost' || host === '127.0.0.1';
}

function isLocalWorkstationHost(hostname) {
  if (typeof hostname !== 'string' || hostname.length === 0) return false;
  const host = hostname.toLowerCase();
  return host === 'localhost' || host.endsWith('.localhost') || IPV4_REGEX.test(host);
}

function isOnBaseDomain(hostname, baseDomain) {
  if (typeof baseDomain !== 'string' || baseDomain.length === 0) {
    throw new TypeError('isOnBaseDomain: baseDomain must be a non-empty string');
  }
  if (typeof hostname !== 'string' || hostname.length === 0) return false;
  const host = hostname.toLowerCase();
  const base = baseDomain.toLowerCase();
  return host === base || host.endsWith(`.${base}`);
}

export {
  stripPort,
  isLocalhostSource,
  isBareLocalHost,
  isLocalWorkstationHost,
  isOnBaseDomain,
  IPV4_REGEX,
};
